function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { isArray } from '@cloud-sn/v-utils';
import { genCascaderKey, getParentChecked, getNodeChecked, getNodeChildCheckState } from '../util';
export default {
  created: function created() {
    this.cascaderStore = {
      nodesMap: {},
      // 存放待确认有效性的值
      pendingValue: [],
      // 转成对象形式方便查找
      pendingValueObj: {}
    };
  },
  methods: {
    createNodes: function createNodes() {
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var labelField = this.labelField,
          valueField = this.valueField,
          childrenField = this.childrenField,
          createNodes = this.createNodes,
          isLazy = this.isLazy,
          registerNode = this.registerNode,
          checkStrict = this.checkStrict,
          pendingValueObj = this.cascaderStore.pendingValueObj;
      var result = [];

      if (nodes.length === 0) {
        return result;
      }

      var parentChecked = getParentChecked(parent);
      nodes.forEach(function (node) {
        var value = node[valueField];
        var valuePath = parent ? [].concat(_toConsumableArray(parent.valuePath), [value]) : [value]; // 使用value路径构建唯一id

        var id = genCascaderKey(valuePath);

        var nodeClone = _objectSpread({}, node, {
          originNode: _objectSpread({}, node),
          parent: parent,
          level: level,
          id: id,
          valuePath: valuePath,
          value: value,
          label: node[labelField],
          children: node[childrenField],
          isLoading: false,
          isLoaded: false,
          isParent: isLazy ? node.isParent !== false : false,
          isChecked: getNodeChecked(pendingValueObj, id, false, parentChecked, node.disabled, checkStrict),
          isIndeterminate: false
        });

        var children = nodeClone.children;

        if (isArray(children) && children.length > 0) {
          nodeClone.children = createNodes(children, nodeClone, level + 1);
          nodeClone.isParent = true;
          nodeClone.isLoaded = true;
          nodeClone.childCheckState = getNodeChildCheckState(nodeClone.children);

          if (!checkStrict) {
            nodeClone.isIndeterminate = nodeClone.childCheckState === 1;
            nodeClone.isChecked = nodeClone.childCheckState === 2 || nodeClone.isChecked;
          }
        }

        registerNode(nodeClone);
        result.push(nodeClone);
      });
      return result;
    },
    registerNode: function registerNode(node) {
      var nodesMap = this.cascaderStore.nodesMap;
      nodesMap[node.id] = node;
    },
    setPendingValue: function setPendingValue(validValue) {
      var cascaderStore = this.cascaderStore;
      cascaderStore.pendingValue = validValue;
      cascaderStore.pendingValueObj = validValue.reduce(function (r, c) {
        var result = r;
        var k = genCascaderKey(c);
        result[k] = true;
        return result;
      }, {});
    },
    getPendingValue: function getPendingValue() {
      return this.cascaderStore.pendingValue;
    },
    clearNodesMap: function clearNodesMap() {
      var cascaderStore = this.cascaderStore;
      cascaderStore.nodesMap = {};
    },
    getNode: function getNode(valuePath) {
      var nodesMap = this.cascaderStore.nodesMap;
      return nodesMap[genCascaderKey(valuePath)];
    },
    addNodes: function addNodes() {
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var createNodes = this.createNodes,
          childrenField = this.childrenField,
          checkStrict = this.checkStrict;
      var nNodes = nodes;
      var nParent = parent;
      var result;

      if (!isArray(nNodes)) {
        nNodes = [nNodes];
      }

      if (nParent) {
        result = createNodes(nNodes, nParent, nParent.level + 1);
        nParent.isParent = result.length > 0;
        nParent.children = result;
        nParent.originNode[childrenField] = result.map(function (node) {
          return node.originNode;
        });
        var isChecked = nParent.isChecked; // 如果父节点未勾选，则需要更新上层节点的勾选状态

        if (!isChecked && !checkStrict) {
          var p = nParent;

          while (p) {
            p.childCheckState = getNodeChildCheckState(p.children);
            p.isIndeterminate = p.childCheckState === 1;
            p = p.parent;
          }
        }
      } else {
        result = createNodes(nNodes, null, 0);
      }

      return result;
    },
    setParentNodeCheckbox: function setParentNodeCheckbox(node) {
      var setParentNodeCheckbox = this.setParentNodeCheckbox;
      var parent = node.parent;

      if (!parent) {
        return;
      } // -1: 无子节点  0: 无勾选子节点  1: 部分子节点勾选  2: 所有子节点被勾选


      var childCheckState = getNodeChildCheckState(parent.children || []);
      parent.childCheckState = childCheckState;

      if (!parent.disabled) {
        switch (childCheckState) {
          case 0:
            parent.isChecked = false;
            parent.isIndeterminate = false;
            break;

          case 1:
            parent.isChecked = false;
            parent.isIndeterminate = true;
            break;

          case 2:
            parent.isChecked = true;
            parent.isIndeterminate = false;
            break;

          default:
            parent.isChecked = false;
            break;
        }
      }

      setParentNodeCheckbox(parent);
    },
    setChildrenNodeCheckbox: function setChildrenNodeCheckbox(node, isChecked) {
      var setChildrenNodeCheckbox = this.setChildrenNodeCheckbox;
      var children = node.children;

      if (children && children.length > 0) {
        children.forEach(function (child) {
          var nChild = child;

          if (!nChild.disabled) {
            nChild.isChecked = isChecked;
            nChild.isIndeterminate = false;
          }

          setChildrenNodeCheckbox(nChild, isChecked);
        });
      }

      var nNode = node;
      nNode.childCheckState = getNodeChildCheckState(children || []);
    },
    checkNodeRelation: function checkNodeRelation(node) {
      var checkStrict = this.checkStrict,
          setChildrenNodeCheckbox = this.setChildrenNodeCheckbox,
          setParentNodeCheckbox = this.setParentNodeCheckbox;

      if (!node || checkStrict) {
        return;
      }

      var isChecked = node.isChecked;
      setChildrenNodeCheckbox(node, isChecked);
      setParentNodeCheckbox(node);
    }
  }
};